import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SpinnerLoader from "../components/spinnerLoader";
import { useNavigate, Link } from "react-router-dom";
import { ForgPassword } from "../functions/authenticate";
import bannerBgSVG from "../assets/media/banner_bg.svg";

export default function ForgotPassword(props) {
  const [userid, setUserId] = useState(null);
  const [useridError, setUserIdError] = useState({ bool: false, value: "" });
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();

  const validateFields = async () => {
    if (!userid) {
      setUserIdError({ bool: true, value: "Invalid UserId" });
      return false;
    } else {
      setUserIdError({ bool: false, value: "" });
    }

    return true;
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    let validate = await validateFields();
    if (validate) {
      setLoad(true);
      const signObj = await ForgPassword(userid, navigate);
      if (signObj) {
        setUserId(null);
      }
    }
    setLoad(false);
  };
  const onChangeTxt = async (event, func) => {
    let value = event.target.value;
    func(value);
  };
  return (
    <Grid container>
      <Grid md={6} lg={6} sm={12} xs={12} className="lgcommonBg lgLeftBg" sx={{backgroundImage: `url(${bannerBgSVG})`}}>
        <Grid className="logoDiv">
          <img src="media/logo.svg" className="logoImg" />
        </Grid>
        <Grid className="roboDiv">
          <img src="media/lock.svg" className="roboImg" />
        </Grid>
      </Grid>
      <Grid md={6} lg={6} sm={12} xs={12} className="lgcommonBg lgRightBg">
        <div className="insideCont customInside2">
          <h1 className="lgTitle">Forgot Password?</h1>
          <p className="lgDesc">
            Don't worry, we have got you covered.
            <br /> Please enter your registered email address below.
          </p>
          {load ? (
            <SpinnerLoader visible={load} />
          ) : (
            <form onSubmit={onSubmit} onDragEnter={onSubmit}>
              <TextField
                fullWidth
                error={useridError.bool}
                id="outlined-error-helper-text"
                label="User ID / Email"
                className="formtext"
                value={userid}
                onChange={(e) => {
                  onChangeTxt(e, setUserId);
                }}
                placeholder="kevin.hector@email.com"
                helperText={useridError.value}
              />
              <Button className="frmbtn" type="submit">
                NEXT
              </Button>
            </form>
          )}
          <div className="subtxt">
            <span className="subtxt">
              <Link to="/login">Back to login</Link>
            </span>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
